<div class="d-flex justify-content-center mb-2">
  <h1>nieuw toernooi</h1>
</div>

<div class="alert alert-info text-center" role="alert">kies 1 van onderstaande opties om een pool te organiseren</div>
<div class="d-flex justify-content-center my-4">
  <button type="button" class="btn btn-lg btn-primary me-4" [routerLink]="['/user/register']">
    <fa-icon [icon]=faUserCircle></fa-icon> registreren
  </button>
  <button type="button" class="btn btn-xl btn-primary ms-4" [routerLink]="['/user/login']">
    <fa-icon [icon]=faSignInAlt></fa-icon> inloggen
  </button>
</div>